<div class="bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <img src="assets/images/logo.png" alt="logo" class="company-logo">
                <h2 class="login-hd-main">Reset Password</h2>
                <p class="login-line">Fill the form to reset ypur password</p>
            </div>
            <div class="col-md-6">
                <div class="content-wrap">
                    <div class="col-md-12">
                        <div class="">
                            <div class="card-body">
                                <form [formGroup]="resetForm">
                                    <h6 class="login-hd">Reset Password</h6>
                                    <div class="form-group">
                                        <label for="password" class="form-label">New Password</label>
                                        <input type="password" placeholder="Enter your Password"
                                            formControlName="password" class="form-control form-input"
                                            [(ngModel)]="ResetPassword.password"
                                            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                            [ngClass]="{ 'is-invalid': submitted && f.password.invalid }">
                                        <div *ngIf="submitted && f.password.invalid" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">Password is required</div>
                                            <div *ngIf="f.password.errors.pattern"> Must contain at least one number and
                                                one uppercase and lowercase letter, and at least 8 or more characters.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="confirmPassword" class="form-label">Confirm Password</label>
                                        <input type="password" placeholder="Confirm your Password"
                                            formControlName="confirmPassword" class="form-control form-input"
                                            pattern="{{f.password.value }}"
                                            [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.invalid }"
                                            required>
                                        <div *ngIf="submitted && f.confirmPassword.invalid" class="invalid-feedback">
                                            <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required
                                            </div>
                                            <div *ngIf="f.confirmPassword.errors.pattern"> Password & Confirm Password
                                                does not match.</div>
                                        </div>
                                    </div>
                                    <div class="col-md-9  col-md-offset-5 ">
                                        <label id="errorMessage"
                                            style="color:#dc3545;font-size:100% ;">{{errorMessage}}</label>
                                    </div>
                                    <button class="btn bg-theme form-btn"
                                        (click)="updateResetPassword()">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

<div class="modal-content">
    <div class="modal-header success-modal-header">
        <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
            <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            <!-- <i class="fa fa-check fa-icon-modal"
                aria-hidden="true"></i> -->
            </h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h3 class="success-text">Success</h3>
                <p class="reset-hd2">Password Reset Successfully.</p>
            </div>
        </div>
        <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
</div>

</ng-template>
<app-footer></app-footer>